import React from 'react';
import PropTypes from 'prop-types';

import MojitoCore from 'mojito/core';

import {SimpleIcon} from './simple-icon.jsx';

const UIViewImplementation = MojitoCore.Presentation.UIViewImplementation;
const uiStyle = MojitoCore.Presentation.uiStyle;
const UIView = MojitoCore.Presentation.UIView;

class IconsRowImpl extends UIViewImplementation {
    render() {
        const {icons, containerStyle} = this.props;
        const iconStyle = uiStyle.merge({margin: '0 2px'}, this.props.iconStyle || {});

        return (
            <div className="IconContainer" style={containerStyle}>
                {icons.map(item => {
                    if (item.intent) iconStyle.cursor = 'pointer';

                    return (
                        <SimpleIcon
                            className={this.props.className}
                            key={item.icon}
                            config={{
                                ...item,
                                iconStyle,
                            }}
                        />
                    );
                })}
            </div>
        );
    }
}

IconsRowImpl.propTypes = {
    icons: PropTypes.arrayOf(
        PropTypes.shape({
            icon: PropTypes.string.isRequired,
            url: PropTypes.string,
            windowName: PropTypes.string,
            intent: PropTypes.object,
            width: PropTypes.number,
            height: PropTypes.number,
            className: PropTypes.string,
            alt: PropTypes.string,
        })
    ).isRequired,
    containerStyle: PropTypes.object,
    iconStyle: PropTypes.object,
    className: PropTypes.string,
};

IconsRowImpl.getStyle = () => {
    return {
        icon: {
            cursor: 'pointer',
            backgroundSize: 'contain',
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'center',
            margin: '0 2px',
        },
    };
};

export const IconsRow = UIView('IconsRow', IconsRowImpl, IconsRowImpl.propTypes);
